import { render, staticRenderFns } from "./ad-population.vue?vue&type=template&id=50eb1bfc"
import script from "./ad-population.vue?vue&type=script&lang=js"
export * from "./ad-population.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports